export const referencesMapper = <
  I extends string,
  C extends string,
  R extends Readonly<{
    code: C;
    _id: I;
    isSelectedByDefault: boolean;
  }>,
>(
  references: readonly R[],
): Readonly<
  readonly [Record<R['code'], R>, Record<R['_id'], R>, R | undefined]
> => {
  const codeMap = {} as Record<R['code'], R>;
  const idMap = {} as Record<R['_id'], R>;
  let defaultReference: R | undefined;

  references.forEach((reference) => {
    codeMap[reference.code] = reference;
    idMap[reference._id] = reference;
    if (reference.isSelectedByDefault) {
      defaultReference = reference;
    }
  });

  return [codeMap, idMap, defaultReference] as const;
};
